/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";
import { Glyphicon } from "react-bootstrap";
import StatusHelper from "../StatusHelper";

const ViewLink = ({ path, jobId }) => (
  <Link className="custom-link" title="View Job" to={`${path}/jobs/${jobId}`}>
    <Glyphicon glyph="eye-open" />
  </Link>
);
ViewLink.propTypes = {
  path: PropTypes.string.isRequired,
  jobId: PropTypes.number.isRequired
};

const CompletedJobListItem = ({ job, path }) => {
  let startAt;
  let endAt;
  if (job.status === "COMPLETED") {
    const format = "D MMM YYYY h:mm A";
    const actualJobStartAt = job.actualStartAt
      ? moment(job.actualStartAt).format(format)
      : "";

    startAt = actualJobStartAt;
    endAt = job.actualEndAt ? moment(job.actualEndAt).format(format) : "";
  } else {
    const dateTimeFormat = "D MMM YYYY";
    startAt =
      job.actualStartAt || job.startAt
        ? moment(job.actualStartAt || job.startAt).format(dateTimeFormat)
        : "";
    endAt =
      job.actualEndAt || job.endAt
        ? moment(job.actualEndAt || job.endAt).format(dateTimeFormat)
        : "";
  }

  const jobType = job.type === "PICKUP" ? "Pickup" : "Delivery";

  return (
    <tr className="content">
      <td>{job.seq}</td>
      <td>{job.customerName}</td>
      <td>{jobType}</td>
      <td>{StatusHelper(job.status)}</td>
      <td>{startAt}</td>
      <td>{endAt}</td>
      <td>
        <ViewLink path={path} jobExternalId={job.externalId} jobId={job.id} />
      </td>
    </tr>
  );
};
CompletedJobListItem.propTypes = {
  job: PropTypes.object.isRequired,
  path: PropTypes.string.isRequired
};

export default CompletedJobListItem;



// WEBPACK FOOTER //
// ./src/components/jobs/CompletedJobListItem.js